import { TFormValue } from '../../../order/order-create-page/order-create-steps/add-lenses-step/add-lenses-step-form';

export const getOrderPoints = (products: TFormValue[]): number => {
  return products.reduce((acc, item) => {
    return acc + (Number(item.singlePoints) * Number(item.productQuantity));
  }, 0);
};
